import { TelegramBot } from './TelegramBot';
export default TelegramBot;